import { Tabs } from 'antd'
import { styled } from '../../theme'
import { BackgroundContainer } from '../../atom/layout/backgroundContainer'
import { withAuthenticatedLayout } from '../../components/layouts/layout'
import DemandManagementTabPrograms from './tab/demand-management-tab-programs'
import { usePeakShavingTranslation } from 'hooks/translation/usePeakShavingTranslation'
import DemandManagementTabParticipants from './tab/demand-management-tab-participants'
import DemandManagementTabEvents from './tab/demand-management-tab-events'

const DemandManagementTabContainer = styled.div`
  .tabs-styling > .ant-tabs-nav {
    margin-bottom: 20px;
    margin-top: 12px;
  }

  .tabs-styling > .ant-tabs-nav > .ant-tabs-nav-wrap > .ant-tabs-nav-list {
    margin-bottom: 0;
  }
`

const DemandManagementBasePage: React.FC = () => {
  document.querySelector('body')?.classList.add('redesignActive')

  const { eventsText, participantsText, programTabTitleText } = usePeakShavingTranslation()
  return (
    <BackgroundContainer>
      <DemandManagementTabContainer>
        <Tabs className="tabs-styling" defaultActiveKey="events">
          <Tabs.TabPane key="events" tab={<span className="regular-cap">{eventsText}</span>}>
            <DemandManagementTabEvents />
          </Tabs.TabPane>
          <Tabs.TabPane key="participants" tab={<span className="regular-cap">{participantsText}</span>}>
            <DemandManagementTabParticipants />
          </Tabs.TabPane>
          <Tabs.TabPane key="programs" tab={<span className="regular-cap">{programTabTitleText}</span>}>
            <DemandManagementTabPrograms />
          </Tabs.TabPane>
        </Tabs>
      </DemandManagementTabContainer>
    </BackgroundContainer>
  )
}

export const DemandManagementPage = withAuthenticatedLayout(DemandManagementBasePage)
